import type { TrailerListResponse } from '@contracts/trailer/TrailerListResponse';
import type { TrailerRequest } from '@contracts/trailer/TrailerRequest';
import type { TrailerWithAxlesResponse } from '@contracts/trailer/TrailerWithAxlesResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { TrailerList } from '@src/trailer/domain/TrailerList';

export const TrailerClient = {
  list: async (clientId: string) => {
    const { data: response } =
      await AuthenticatedClient.get<TrailerListResponse>(
        `clients/${clientId}/trailers`,
      );

    return new TrailerList(response.trailers);
  },
  get: async (clientId: string, trailerId: string) => {
    const { data: response } =
      await AuthenticatedClient.get<TrailerWithAxlesResponse>(
        `clients/${clientId}/trailers/${trailerId}`,
      );

    return response;
  },
  update: async (
    clientId: string,
    trailerId: string,
    data: TrailerRequest,
  ): Promise<TrailerWithAxlesResponse> => {
    const { data: response } =
      await AuthenticatedClient.put<TrailerWithAxlesResponse>(
        `clients/${clientId}/trailers/${trailerId}`,
        data,
      );

    return response;
  },
  create: async (
    clientId: string,
    data: TrailerRequest,
  ): Promise<TrailerWithAxlesResponse> => {
    const { data: response } =
      await AuthenticatedClient.post<TrailerWithAxlesResponse>(
        `clients/${clientId}/trailers`,
        data,
      );

    return response;
  },
  delete: async (clientId: string, trailerId: string): Promise<void> => {
    await AuthenticatedClient.post<void>(
      `clients/${clientId}/trailers/${trailerId}/delete`,
    );
  },
};
